import type { PointerEvent as ReactPointerEvent, RefObject, WheelEvent as ReactWheelEvent } from 'react'

type Offset = { x: number; y: number }

type Props = {
  containerRef: RefObject<HTMLDivElement | null>
  isDarkMode: boolean
  isDragging: boolean
  scale: number
  offset: Offset
  imageUrl: string
  imageAlt: string
  onApplyScale: (value: number) => void
  onWheel: (event: ReactWheelEvent<HTMLDivElement>) => void
  onPointerDown: (event: ReactPointerEvent<HTMLDivElement>) => void
  onPointerMove: (event: ReactPointerEvent<HTMLDivElement>) => void
  onPointerUp: (event: ReactPointerEvent<HTMLDivElement>) => void
  onPointerCancel: (event: ReactPointerEvent<HTMLDivElement>) => void
}

export const ZoomViewport = ({
  containerRef,
  isDarkMode,
  isDragging,
  scale,
  offset,
  imageUrl,
  imageAlt,
  onApplyScale,
  onWheel,
  onPointerDown,
  onPointerMove,
  onPointerUp,
  onPointerCancel,
}: Props) => (
  <div
    ref={containerRef}
    className={`relative min-h-0 flex-1 overflow-hidden rounded-xl border select-none touch-none ${
      isDarkMode ? 'border-slate-700 bg-slate-950' : 'border-slate-200 bg-slate-50'
    } ${scale > 1 ? (isDragging ? 'cursor-grabbing' : 'cursor-grab') : 'cursor-zoom-in'}`}
    onDoubleClick={() => onApplyScale(scale > 1 ? 1 : 2)}
    onWheel={onWheel}
    onPointerDown={onPointerDown}
    onPointerMove={onPointerMove}
    onPointerUp={onPointerUp}
    onPointerCancel={onPointerCancel}
  >
    <img
      src={imageUrl}
      alt={imageAlt}
      loading="eager"
      decoding="async"
      draggable={false}
      className="h-full w-full object-contain"
      style={{
        transform: `translate3d(${offset.x}px, ${offset.y}px, 0) scale(${scale})`,
        transition: isDragging ? 'none' : 'transform 120ms ease-out',
        transformOrigin: 'center center',
      }}
    />
  </div>
)
